export function FormField({
  label,
  required,
  hint,
  error,
  id,
  children,
}) {
  return (
    <div className="form-group">
      <label className="form-label" htmlFor={id}>
        {label}
        {required && <span className="required" aria-label="required"> *</span>}
      </label>
      {children}
      {hint && !error && <p className="form-hint">{hint}</p>}
      {error && <p className="form-error" role="alert">{error}</p>}
    </div>
  );
}

export function Input({ id, error, ...props }) {
  return (
    <input
      id={id}
      className={`form-input${error ? ' error' : ''}`}
      {...props}
    />
  );
}

export function Select({ id, error, children, ...props }) {
  return (
    <select id={id} className={`form-select${error ? ' error' : ''}`} {...props}>
      {children}
    </select>
  );
}

export function Textarea({ id, error, ...props }) {
  return (
    <textarea id={id} className={`form-textarea${error ? ' error' : ''}`} {...props} />
  );
}
